
import React from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import { Separator } from '@/components/ui/separator';
import { ShieldAlert, Award, CheckCircle2, AlertCircle, ThumbsUp } from 'lucide-react';

const Safety = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />
      
      <main className="flex-grow pt-16">
        {/* Hero section */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-brand-50 to-white"></div>
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
            <div className="text-center max-w-3xl mx-auto">
              <h1 className="text-3xl md:text-4xl font-bold mb-6">Siguria</h1>
              <p className="text-lg text-gray-600 mb-8">
                Këshilla dhe udhëzime për të mbajtur të sigurt eksperiencën tuaj në TreguIm.
              </p>
            </div>
          </div>
        </section>
        
        {/* Safety guidelines */}
        <section className="py-16">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm border border-gray-100 p-8 mb-12">
              <div className="flex items-center mb-6">
                <ShieldAlert size={24} className="text-brand-500 mr-3" />
                <h2 className="text-2xl font-bold">Udhëzime për siguri</h2>
              </div>
              
              <div className="prose prose-stone max-w-none">
                <p>
                  Siguria është prioriteti ynë kryesor në TreguIm. Ndërsa shumica e transaksioneve dhe ndërveprimeve në platformën tonë janë të sigurta dhe legjitime, 
                  është gjithmonë e mençur të ndiqni këto udhëzime për të mbrojtur veten dhe informacionin tuaj.
                </p>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow">
                <div className="flex items-center mb-4">
                  <div className="bg-green-50 text-green-500 p-3 rounded-full mr-4">
                    <CheckCircle2 size={20} />
                  </div>
                  <h3 className="text-xl font-semibold">Për blerësit</h3>
                </div>
                
                <ul className="space-y-3 text-gray-600">
                  <li className="flex items-start">
                    <ThumbsUp size={16} className="text-brand-500 mt-1 mr-2 flex-shrink-0" />
                    <span>Kontrolloni vlerësimet dhe komente për shitësin para se të bëni një blerje.</span>
                  </li>
                  <li className="flex items-start">
                    <ThumbsUp size={16} className="text-brand-500 mt-1 mr-2 flex-shrink-0" />
                    <span>Kërkoni foto dhe detaje shtesë për artikullin nëse ato që jepen nuk janë të mjaftueshme.</span>
                  </li>
                  <li className="flex items-start">
                    <ThumbsUp size={16} className="text-brand-500 mt-1 mr-2 flex-shrink-0" />
                    <span>Takohuni në vende publike dhe të sigurta për të parë dhe blerë artikullin.</span>
                  </li>
                  <li className="flex items-start">
                    <ThumbsUp size={16} className="text-brand-500 mt-1 mr-2 flex-shrink-0" />
                    <span>Preferoni pagesat me para në dorë ose metoda të sigurta pagese.</span>
                  </li>
                  <li className="flex items-start">
                    <ThumbsUp size={16} className="text-brand-500 mt-1 mr-2 flex-shrink-0" />
                    <span>Mos jepni informacione personale ose financiare që nuk janë të nevojshme për transaksionin.</span>
                  </li>
                  <li className="flex items-start">
                    <ThumbsUp size={16} className="text-brand-500 mt-1 mr-2 flex-shrink-0" />
                    <span>Inspektoni artikullin me kujdes përpara pagesës.</span>
                  </li>
                  <li className="flex items-start">
                    <ThumbsUp size={16} className="text-brand-500 mt-1 mr-2 flex-shrink-0" />
                    <span>Kërkoni faturë ose dëftesë për artikullin e blerë.</span>
                  </li>
                </ul>
              </div>
              
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow">
                <div className="flex items-center mb-4">
                  <div className="bg-green-50 text-green-500 p-3 rounded-full mr-4">
                    <CheckCircle2 size={20} />
                  </div>
                  <h3 className="text-xl font-semibold">Për shitësit</h3>
                </div>
                
                <ul className="space-y-3 text-gray-600">
                  <li className="flex items-start">
                    <ThumbsUp size={16} className="text-brand-500 mt-1 mr-2 flex-shrink-0" />
                    <span>Jepni informacione të sakta dhe të detajuara për artikullin që po shisni.</span>
                  </li>
                  <li className="flex items-start">
                    <ThumbsUp size={16} className="text-brand-500 mt-1 mr-2 flex-shrink-0" />
                    <span>Postoni foto të qarta dhe realiste të artikullit nga kënde të ndryshme.</span>
                  </li>
                  <li className="flex items-start">
                    <ThumbsUp size={16} className="text-brand-500 mt-1 mr-2 flex-shrink-0" />
                    <span>Përgjigjuni pyetjeve të blerësve me sinqeritet dhe në kohë.</span>
                  </li>
                  <li className="flex items-start">
                    <ThumbsUp size={16} className="text-brand-500 mt-1 mr-2 flex-shrink-0" />
                    <span>Takohuni në vende publike për të dorëzuar artikullin.</span>
                  </li>
                  <li className="flex items-start">
                    <ThumbsUp size={16} className="text-brand-500 mt-1 mr-2 flex-shrink-0" />
                    <span>Jini të kujdesshëm me pagesat elektronike; sigurohuni që fondet janë transferuar përpara se të dorëzoni artikullin.</span>
                  </li>
                  <li className="flex items-start">
                    <ThumbsUp size={16} className="text-brand-500 mt-1 mr-2 flex-shrink-0" />
                    <span>Ruani të dhënat e komunikimit me blerësin për referencë të mëvonshme.</span>
                  </li>
                  <li className="flex items-start">
                    <ThumbsUp size={16} className="text-brand-500 mt-1 mr-2 flex-shrink-0" />
                    <span>Jepni faturë ose dëftesë për artikullin e shitur.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        
        {/* Red flags section */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-2xl font-bold mb-3">Shenjat e rrezikut për t'u vërejtur</h2>
                <p className="text-gray-600 max-w-2xl mx-auto">
                  Mësoni të identifikoni situatat e dyshimta dhe mashtrimet e mundshme kur përdorni platformën tonë.
                </p>
              </div>
              
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="bg-red-50 text-red-500 p-3 rounded-full mr-4 flex-shrink-0">
                      <AlertCircle size={20} />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg mb-2">Çmime jashtëzakonisht të ulëta</h3>
                      <p className="text-gray-600">
                        Nëse një ofertë duket shumë e mirë për të qenë e vërtetë, zakonisht nuk është e vërtetë. Çmimet jashtëzakonisht të ulëta për artikuj me 
                        vlerë të lartë janë shpesh një taktikë e përdorur nga mashtruesit.
                      </p>
                    </div>
                  </div>
                  
                  <Separator />
                  
                  <div className="flex items-start">
                    <div className="bg-red-50 text-red-500 p-3 rounded-full mr-4 flex-shrink-0">
                      <AlertCircle size={20} />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg mb-2">Kërkesa për informacione të panevojshme</h3>
                      <p className="text-gray-600">
                        Jini të kujdesshëm nëse dikush ju kërkon informacione personale ose financiare që nuk janë të nevojshme për transaksionin. 
                        Mashtruesit mund të kërkojnë detaje të kartës së kreditit, të dhëna bankare, ose dokumente identifikimi.
                      </p>
                    </div>
                  </div>
                  
                  <Separator />
                  
                  <div className="flex items-start">
                    <div className="bg-red-50 text-red-500 p-3 rounded-full mr-4 flex-shrink-0">
                      <AlertCircle size={20} />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg mb-2">Metoda pagese të pazakonta</h3>
                      <p className="text-gray-600">
                        Kini kujdes nga kërkesat për pagesa me metoda të pazakonta ose të pakthyeshme, si transferta bankare ndërkombëtare, 
                        karta dhuratë, ose kriptomonedha. Këto metoda janë të vështira për t'u gjurmuar dhe zakonisht nuk ofrojnë mbrojtje për blerësin.
                      </p>
                    </div>
                  </div>
                  
                  <Separator />
                  
                  <div className="flex items-start">
                    <div className="bg-red-50 text-red-500 p-3 rounded-full mr-4 flex-shrink-0">
                      <AlertCircle size={20} />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg mb-2">Shtypja për të marrë vendime të shpejta</h3>
                      <p className="text-gray-600">
                        Nëse dikush ju shtyn të merrni një vendim të shpejtë ose ju bën presion për të paguar menjëherë, kjo mund të jetë një 
                        taktikë për t'ju mos ju lejuar të mendoni qartë ose të bëni kërkime shtesë.
                      </p>
                    </div>
                  </div>
                  
                  <Separator />
                  
                  <div className="flex items-start">
                    <div className="bg-red-50 text-red-500 p-3 rounded-full mr-4 flex-shrink-0">
                      <AlertCircle size={20} />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg mb-2">Refuzimi për t'u takuar personalisht</h3>
                      <p className="text-gray-600">
                        Jini të kujdesshëm me shitësit që refuzojnë të takohen personalisht ose të lejojnë inspektimin e artikullit përpara pagesës. 
                        Kjo mund të jetë një shenjë se artikulli nuk ekziston ose nuk është ashtu siç përshkruhet.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        {/* Report section */}
        <section className="py-16">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
              <div className="bg-brand-50 rounded-xl p-8 border border-brand-100">
                <div className="flex flex-col md:flex-row items-center justify-between">
                  <div className="md:w-2/3 mb-6 md:mb-0">
                    <div className="flex items-center mb-4">
                      <Award size={24} className="text-brand-500 mr-3" />
                      <h2 className="text-2xl font-bold">E keni vërejtur diçka të dyshimtë?</h2>
                    </div>
                    <p className="text-gray-600 mb-4">
                      Nëse keni ndeshur me një përdorues apo shpallje të dyshimtë, ose nëse mendoni se jeni viktimë e një mashtrimi, 
                      ju lutemi na njoftoni menjëherë. Ekipi ynë i sigurisë është këtu për t'ju ndihmuar.
                    </p>
                    <p className="text-gray-600">
                      Raportimet tuaja na ndihmojnë të mbajmë TreguIm një platformë të sigurt për të gjithë.
                    </p>
                  </div>
                  
                  <div className="md:w-1/3 text-center">
                    <a href="/contact" className="inline-block bg-brand-500 hover:bg-brand-600 text-white py-3 px-6 rounded-full font-medium transition-colors">
                      Raporto një problem
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default Safety;
